import { createSelector } from 'reselect';
import MultiplePredesDetailsColumns from '../../containers/MultiplePredesDetailsColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.MULTIPLE_PREDES_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.MULTIPLE_PREDES_DETAILS.isLoading;

export const getData =
  ReportDefinitions.MULTIPLE_PREDES_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, MultiplePredesDetailsColumns);
